module.exports = __webpack_public_path__ + "files/bb776475dffdea5605803a29d8d404bc.png";